module.exports = __webpack_public_path__ + "fonts/OpenSans600.908f2f83.woff";